<template>
    <div>
        <el-container style="height: 100vh">

            <el-aside width="235px">
                <div
                    style="display: flex;justify-content: center;align-items: center;height: 50px;border-bottom: 1px solid gray">
                    <p style="font-size: 20px;color: #FFFFFF">智享订房系统</p>
                </div>
                <el-menu :default-active="active" @open="handleOpen" @close="handleClose" background-color="#545c64"
                    text-color="#fff" active-text-color="#ffd04b">

                    <TreeMenu v-for="(item, key) in menuList" :menu="item" :key="key"/>

                </el-menu>

            </el-aside>

            <el-container>
                <el-header height="50px">
                    <div class="user-info">
                        <img class="user-img mr-10" :src="userInfo.heads" alt="">
                        <el-dropdown trigger="click">
                            <span class="el-dropdown-link">
                                <p> {{ userInfo.nickname }}</p>
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown"  class="top_r_list">
                                <div class="other_list">
                                    <el-dropdown-item @click.native="goHome">
                                        <i class="el-icon-s-home"></i>
                                        <span>首页</span>
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="openUserInfo">
                                        <i class="el-icon-user-solid"></i>
                                        <span>个人信息</span>
                                    </el-dropdown-item>
                                </div>
                                 <el-dropdown-item @click.native="logout" class="login_out">
                                    <i class="el-icon-switch-button"></i>
                                    <span>退出登录</span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </el-header>
                <el-main>
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>

    </div>
</template>

<script>
import { get, post, getMenuList, getButtonList } from "../utils/request";

import TreeMenu from "../components/TreeMenu";

export default {
    name: "index",
    components: {
        TreeMenu,
    },
    computed: {
        menuList() {
            return this.$store.state.menuList || [];
        },
        userInfo() {
            return this.$store.state.userInfo || {};
        },
    },
    data() {
        return {
            active: ''

        }
    },
    methods: {
        handleOpen(key, keyPath) {
            // console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            // console.log(key, keyPath);
        },

        //根据id获取用户信息
        getUserInfo() {
            this.userId = localStorage.getItem('userId')
            get('/api/user/get/' + this.userId)
                .then(res => {
                    let data = res.data;
                    if(data.code == 200) {
                        this.$store.commit("UPDATE_USERINFO",data.data)
                    }
                })
                .catch(err => {
                    // console.log(err);
                })
        },

        //路由跳转方法
        toOtherComponent(val, data) {
            this.$router.push({
                name: val,
                query: {
                    data: data
                }
            })
        },

        // 获取菜单列表
        getMenuList() {

            this.menuList = JSON.parse(localStorage.getItem('menuList'))

        },

        openUserInfo() {
            this.$router.push({
                path: '/index/userInfo'
            })
        },
        goHome() {
            this.$router.push({
                path: '/index'
            })
        },

        //退出登录
        logout() {
            this.$router.push({
                path: '/'
            })

        }

    },
    created() {
        getMenuList();
        getButtonList(this, "refresh");
    },
    mounted() {
        this.getUserInfo()
        // // console.log(this.$store.state.menuList);

        this.active = localStorage.getItem('menuId') ? localStorage.getItem('menuId') : "1"
    }
}
</script>

<style scoped>
/* 自定样式 start */
.user-info {
    display: flex;
    align-items: center;
}

.user-img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
}

/* 自定样式 end */

/* 自定样式 ling start */

/* 自定样式 ling end */

.el-row {
    margin-bottom: 0;
}

.el-header {
    display: flex;
    align-items: center;
}

.el-main {
    background-color: #F1F7FC;
    color: #333;
    padding: 15px;
}

body>.el-container {
    margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
    line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
    line-height: 320px;
}

.el-dropdown-link {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #409EFF;
}

.el-icon-arrow-down {
    font-size: 12px;
}

.el-aside {
    height: 100vh;
    /*background: #F0F2F3;*/
    background: #545c64;
    /*width: 340px;*/
}

.el-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    background: #FFFFFF;
    box-shadow: 5px 5px 8px 0 rgba(0, 0, 0, 0.15);
    z-index: 9;
    padding: 0px 25px;
}

.el-menu {
    height: calc(100% - 110px);
    margin-top: 20px;
    border: none;
}

.el-menu .el-menu-item {
    /*background-color: #F0F2F3!important;*/
    /*background-color: #e1e3e5 !important;*/
    height: 45px;
    line-height: 45px;
}

.el-menu .el-menu-item,
.el-menu .el-submenu__title {
    height: 45px !important;
    line-height: 45px !important;
}

/*.el-menu-item:hover {*/
/*    background: none !important;*/
/*    outline: none !important;*/
/*}*/

.el-menu .is-active {
    background: linear-gradient(90deg, #428DFF, #397DFF) !important;
    border-radius: 0px !important;
}

.el-main {
    background-color: #F4F8FC;
}

.el-avatar>img {
    width: 100%;
}

.avatar-uploader {
    margin-left: 35px;
}

.main-container {
    background: #FFFFFF;
    box-shadow: 0px 5px 30px 0px rgba(22, 115, 255, 0.1);
    padding: 20px;
    border-radius: 6px;
}
.top_r_list  .other_list {
    width: 180px;
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
    box-sizing: border-box;
}

.top_r_list  .other_list .el-dropdown-menu__item {
    width: 60px;
    display: flex;
    flex-direction: column;
    font-size: 11px;
    word-break: keep-all;
    text-align: center;
    padding: 5px 10px;
}

.top_r_list  .other_list .el-dropdown-menu__item i {
    font-size: 16px;
    margin: 0;
}
.top_r_list .login_out {
    text-align: center;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.top_r_list .login_out i {
    font-size: 16px;
}
</style>